import { type ReactElement } from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider, MessageFormatElement } from 'react-intl';

import type { Suggestion } from '../auto-completion/autocompletion-types.js';

/** @internal */
export interface IntlProps {
  locale: string;
  messages: Record<string, string> | Record<string, MessageFormatElement[]>;
  defaultLocale: string;
}

/**
 * Renders the suggestion on auto-completion.
 * @param suggestion - Suggestion for the auto-completion
 * @param component - Autocompletion source component
 */
export function render(
  suggestion: Suggestion,
  Component:
    | (({ suggestion }: { suggestion: Suggestion }) => ReactElement)
    | undefined,
  intlProps: IntlProps,
) {
  if (Component) {
    const element = document.createElement('div');

    const root = createRoot(element);
    root.render(
      <IntlProvider {...intlProps}>
        <Component suggestion={suggestion} />
      </IntlProvider>,
    );
    return element as Node;
  }
  return null;
}
